<template>
  <div class="pt-1">
    <v-icon @click="show = !show">fas fa-info-circle</v-icon>
    <v-dialog v-model="show" width="70%">
      <v-card class="grayText">
        <v-card-title> Searching & Special Characters </v-card-title>
        <v-card-text>
          <div class="pb-5">
            Seerist supports advanced search operators to extend regular text
            searches to build more precise searches. These searches can be
            paired with the filters below and saved as queries to be re-used at
            any time.
          </div>
          <table class="info-table">
            <tr>
              <th>Operator</th>
              <th>Description</th>
              <th>Example Search</th>
              <th>Example Content</th>
            </tr>
            <tr>
              <td>""</td>
              <td>Placed around a phrase to search for exact matches.</td>
              <td>"Breaking News"</td>
              <td>
                <span class="application-heading">Breaking News</span> -
                Explosion in Antarctica
              </td>
            </tr>
            <tr>
              <td>+</td>
              <td>Placed before a word to include it in results.</td>
              <td>+protest +police</td>
              <td>
                The <span class="application-heading">protest</span> was met
                with a large
                <span class="application-heading">police</span> presence
              </td>
            </tr>
            <tr>
              <td>|</td>
              <td>Placed between words to include either in results.</td>
              <td>protest | demonstration</td>
              <td>
                A <span class="application-heading">demonstration</span> is
                planned for the central plaza at 7:00am
              </td>
            </tr>
            <tr>
              <td>-</td>
              <td>Placed before a word to exclude it from results.</td>
              <td>protest -police</td>
              <td>
                The <span class="application-heading">protest</span> passed
                peacefully
              </td>
            </tr>
            <tr>
              <td>*</td>
              <td>
                Placed at the end of a word to include the word as a prefix in
                results.
              </td>
              <td>protest*</td>
              <td>
                <span class="application-heading">Protesters</span> gathered
                outside the Presidential Palace
              </td>
            </tr>
            <tr>
              <td>()</td>
              <td>Placed around multiple words to allow grouping of terms.</td>
              <td>+(protest | demonstration) +(police | clashes)</td>
              <td>
                The <span class="application-heading">protest</span> resulted in
                <span class="application-heading">clashes</span> with guards in
                the area
              </td>
            </tr>
            <tr>
              <td>~N</td>
              <td>
                Placed after a search to return content where the words are N
                words apart.
              </td>
              <td>+protest +injury ~5</td>
              <td>
                The <span class="application-heading">protest</span> resulted in
                one
                <span class="application-heading">injury</span>
              </td>
            </tr>
            <tr>
              <td>~</td>
              <td>
                Placed after a word to return content where results differ from
                the word by one letter.
              </td>
              <td>blow~</td>
              <td>
                Separatists <span class="application-heading">blew</span> up an
                oil pipeline in the area.
              </td>
            </tr>
          </table>
        </v-card-text>
        <v-card-title class="pt-0"> Social Searching </v-card-title>
        <v-card-text>
          <div class="pb-5">
            Seerist searches also search through social media. Hashtags and "@"
            symbols do not need to be included to find specific handles or
            trending phrases
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "KeywordSearchInfo",
  props: {
    features: {
      type: Array,
    },
  },
  data: function () {
    return {
      show: false,
    };
  },
  methods: {
    openModal: async function (geohash) {
      this.showDelete = true;
    },
  },
};
</script>

<style scoped>
.grayText > * {
  color: #717173 !important;
}
.info-table {
  width: 100%;
}
.info-table tr th {
  text-align: left;
  padding-left: 5px;
  padding-right: 5px;
}
.info-table tr td {
  border-width: 1px !important;
  border-style: solid;
  border-color: #e6e6e6;
  padding-left: 5px;
  padding-right: 5px;
}
</style>
